import { ConnectorType } from 'apollo/generated/client-operations';
import { avigilonAccessConnectorCatalogEntry } from './avigilonAccess/avigilonAccessConnectorCatalogEntry';
import { avigilonVideoConnectorCatalogEntry } from './avigilonVideo/avigilonVideoConnectorCatalogEntry';
import type { ConnectorCatalogEntry } from './connectorCatalogEntry';

const entriesByType: Record<ConnectorType, ConnectorCatalogEntry> = {
  [ConnectorType.AvigilonAccess]: avigilonAccessConnectorCatalogEntry,
  [ConnectorType.AvigilonVideo]: avigilonVideoConnectorCatalogEntry,
};

export const connectorCatalog = {
  getEntry(type: ConnectorType): ConnectorCatalogEntry {
    const entry = entriesByType[type];
    if (!entry) throw new Error(`Unknown Connector type: ${String(type)}`);
    return entry;
  },
};
